<template>
  <SoPageWithRightSidePanel v-model="current.isSidePanelCollapsed">
    <SoContainer fluid>
      <SoRow>
        <SoCol>
          <AgreementsTable></AgreementsTable>
        </SoCol>
      </SoRow>
    </SoContainer>
    <template #sidePanel>
      <CustomerAccountInfoPanel></CustomerAccountInfoPanel>
    </template>
    <template #sidePanelRail>
      <CustomerAccountInfoRail></CustomerAccountInfoRail>
    </template>
  </SoPageWithRightSidePanel>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import SoPageWithRightSidePanel from "@/components/templates/SoPageWithRightSidePanel.vue"
  import CustomerAccountInfoPanel from "../overview/CustomerAccountInfoPanel.vue"
  import CustomerAccountInfoRail from "../overview/CustomerAccountInfoRail.vue"
  import SoContainer from "@/components/SoContainer.vue"
  import SoRow from "@/components/SoRow.vue"
  import SoCol from "@/components/SoCol.vue"
  import AgreementsTable from "@/views/customer/agreements/components/AgreementsTable.vue"
  export default defineComponent({
    components: {
      SoPageWithRightSidePanel,
      CustomerAccountInfoPanel,
      CustomerAccountInfoRail,
      SoContainer,
      SoRow,
      SoCol,
      AgreementsTable,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
      }
    },
  })
</script>
